import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Badge from '@mui/material/Badge';
import { NavLink } from 'react-router-dom';
import {
  selectUnreadCount,
  selectUnreadArchivedCount,
} from 'store/modules/conversations/selectors';

export const NavItem = ({ to, exact, label, secondary }) => (
  <ListItem
    button
    component={NavLink}
    to={to}
    exact={exact}
    activeClassName="Mui-selected"
  >
    <ListItemText
      primary={label}
      primaryTypographyProps={{
        fontWeight: '600',
        sx: {
          color: 'inherit',
        },
      }}
    />
    {secondary && (
      <ListItemSecondaryAction>{secondary}</ListItemSecondaryAction>
    )}
  </ListItem>
);

export default () => {
  const [t] = useTranslation('messages');
  const unread = useSelector(selectUnreadCount);
  const unreadArchived = useSelector(selectUnreadArchivedCount);

  return (
    <List>
      <NavItem
        to="/messages/inbox"
        label={t('common:inbox', 'Inbox')}
        secondary={
          unread ? (
            <Badge
              color="default"
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                },
              }}
              badgeContent={unread}
            />
          ) : null
        }
      />
      <NavItem
        to="/messages/archived"
        label={t('common:archived', 'Archived')}
        secondary={
          unreadArchived ? (
            <Badge
              color="default"
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                },
              }}
              badgeContent={unreadArchived}
            />
          ) : null
        }
      />
      <NavItem to="/messages/sent" label={t('common:sent', 'Sent')} />
      <NavItem to="/messages/pending" label={t('common:pending', 'Pending')} />
      <NavItem to="/messages/templates" label={t('templates', 'Templates')} />
    </List>
  );
};
